import withTracker from './tracker';

import {
    EmailNum,
    Password,
    Forget,
    SetPwd,
    Update,
    NewPwd,
    Profile,
    Delete,
    Age,
    Guardian,
    Agreement,
    Ifttt,
    Connect,
    NoDriver,
    ConnectUnable,
    // Upload,
    Firmware,
    ConfirmSave,
    UpdaterAppRestart,
    UpdaterFirmware,
    UpdaterFirmwareNotMatch,
    UpdaterFirmwareProgress,
    Example,
    Extensions,
    Calibrate,
    Sprites,
    Loading,
    SaveAs,
    WebSaveAs,
    About,
    Feedback,
    ProjectsWeb,
    ShareProjectTo,
} from './lazy-routers';
// 懒加载下初次加载on事件未初始化,msg接收失败
import Upload from '../upload/upload';

export default [
    {
        url: '/login',
        component: withTracker(EmailNum),
        exact: true
    },
    {
        url: '/login/:type',
        component: withTracker(Password)
    },
    {
        url: '/profile',
        component: withTracker(Profile),
        exact: true
    },
    {
        url: '/profile/delete',
        component: withTracker(Delete)
    },
    {
        url: '/forget',
        component: withTracker(Forget),
        exact: true
    },
    {
        url: '/forget/setPwd',
        component: withTracker(SetPwd)
    },
    {
        url: '/update',
        component: withTracker(Update),
        exact: true
    },
    {
        url: '/update/newPwd',
        component: withTracker(NewPwd)
    },
    {
        url: '/age',
        component: withTracker(Age)
    },
    {
        url: '/guardian',
        component: withTracker(Guardian)
    },
    {
        url: '/agreement',
        component: withTracker(Agreement)
    },
    {
        url: '/user/ifttt',
        component: Ifttt
    },
    {
        url: '/projects',
        component: withTracker(ProjectsWeb)
    },
    {
        url: '/help/about',
        component: withTracker(About)
    },
    {
        url: '/help/feedback',
        component: withTracker(Feedback)
    },
    {
        url: '/help/shareprojectto',
        component: withTracker(ShareProjectTo)
    },
    {
        url: '/connect',
        component: Connect
    },
    {
        url: '/nodriver',
        component: NoDriver
    },
    {
        url: '/device/unrecognized',
        component: ConnectUnable
    },
    {
        url: '/upload/code',
        component: Upload
    },
    {
        url: '/confirm/save/:type',
        component: ConfirmSave
    },
    {
        url: '/updater/app/restart',
        component: UpdaterAppRestart
    },
    {
        url: '/updater/firmware',
        component: UpdaterFirmware,
        exact: true
    },
    {
        url: '/updater/firmware/notmatch',
        component: UpdaterFirmwareNotMatch,
        exact: true
    },
    {
        url: '/updater/firmware/progress',
        component: UpdaterFirmwareProgress,
        exact: true
    },
    {
        url: '/example',
        component: Example
    },
    {
        url: '/exts',
        component: Extensions,
        exact: true
    },
    {
        url: '/calibrate/:type',
        component: Calibrate,
        exact: true
    },
    {
        url: '/sprite/:type',
        component: Sprites
    },
    {
        url: '/loading',
        component: Loading
    },
    {
        url: '/project/saveas/:type/:name',
        component: SaveAs
    },
    {
        url: '/web/saveas',
        component: WebSaveAs
    },
];